import { ATOM_KEY } from "@/shared/client/keys";
import { atom, useRecoilState, useRecoilValue, useSetRecoilState } from "recoil";
import { type SelectedRoom } from "../types";

const selectedRoomAtom = atom<SelectedRoom[]>({
    default: [],
    key: ATOM_KEY.SELECTED_RESERVE_ROOM,
});

export const useSelectedRoomState = () => useRecoilState(selectedRoomAtom);
export const useSetSelectedRoomState = () => useSetRecoilState(selectedRoomAtom);
export const useSelectedRoomValue = () => useRecoilValue(selectedRoomAtom);
